import {Injectable} from '@angular/core';
import {ApiEvsService} from 'app/common/services/ApiEvs.service';

@Injectable()
export class BatchstampService {
  constructor(private http: ApiEvsService) {
  }

  public GetNumberStamps() {
    return this.http.get('/roles/current');
  }

  public CreateBatchStamp(request) {
    return this.http.post('/items_order', request);
  }

  public ListOrder(request) {
    return this.http.get('/items_order', request);
  }

  public getStampService() {
    return this.http.get('/stamp_services');
  }

  public getDetailsOrder(id) {
    return this.http.get('/items_order/' + id);
  }

  public DeleteOrder(id) {
    return this.http.delete('/items_order/' + id);
  }

  public PaymentOrder(id, request) {
    return this.http.post('/items_order/' + id + '/payment', request);
  }

  public getListStamp(request) {
    return this.http.get('/stamps', request);
  }

  public GetStampStatic(request) {
    return this.http.get('/stamps/statistic', request);
  }

  public getMessageOrder(request) {
    return this.http.get('/message_order', request);
  }

  public GetListStamp(request) {
    return this.http.get('/stamps', request);
  }

  public ExportExcel(id, request) {
    return this.http.post('/items_order/' + id + '/excel', request);
  }

  public findStamp(id) {
    return this.http.get('/stamps/find/' + id);
  }

  public updateMessage(orderId, service, request) {
    return this.http.put(/message_order/ + orderId + '/' + service, request);
  }

  public downloadExcel(id) {
    this.http.getexcel('/items_order/' + id + '/excel/download');
  }

  public getDistribution(data: any) {
    return this.http.get('/distribution', data);
  }

  public downloadExcelDistribution(request: any) {
    return this.http.getExcel('/distribution/excel', request);
  }

  public getDistributionDetail(id: any) {
    return this.http.get('/distribution/detail/' + id);
  }

  public getRestores(data: any) {
    return this.http.get('/restores', data);
  }

  public downloadExcelRestore(request: any) {
    return this.http.getExcel('/restores/excel', request);
  }

  public getRestoreDetail(id: any) {
    return this.http.get('/restores/' + id);
  }

  public restoreStamp(body: any) {
    return this.http.post('/qr_aps/restores', body);
  }

  public restoreListStamp(body: any) {
    return this.http.post('/qr_aps/mobile/restores', body);
  }

  public restoreDistribution(id: any, body) {
    return this.http.put('/restores/' + id, body);
  }




}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/batchstamp/batchstamp.service.ts